module.exports = {
       // props: ['items','mutilCheck'],
        data:function(){
            return {
              user:localStorage.username
            }
        },
        methods:{
          loginout:function(){
              localStorage['token']='';
              window.location.href='./login.html'
            },
            clickHandler:function(index){
                //多选
                if(this.mutilCheck){
                    this.items[index].checked = !this.items[index].checked;
                } else {
                    //单选
                    for (var i = this.items.length - 1; i >= 0; i--) {
                        this.items[i].checked = (i === index)
                    };
                }
            }
        },
        components:{
          dropdown:require('vue-strap').dropdown
        }
    }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/navbar.vue
// module id = 39
// module chunks = 0